import { z } from 'zod/v4';
import {
  ACCESSIBLE_IMAGE_SCHEMA,
  DEFAULT_ACCESSIBLE_IMAGE_EMPTY,
  IAccessibleImage,
} from './image.interfaces';
import { ERelationType } from './text-relation-type.enums';
import { INormalText, NORMAL_TEXT_SCHEMA } from './text/text.interfaces';
import { ETextType } from './text/text.enums';
import { Brand } from '../branded-types';
import { LanguagePrefix } from './language.interfaces';

export type CustomTileId = Brand<string, 'customTileId'>;

export const CUSTOM_TILE_SCHEMA: z.ZodType<ICustomTile> = z.object({
  id: z
    .string()
    .transform((s: string) => s as CustomTileId)
    .optional(),
  isActive: z.boolean(),
  accessibleImage: ACCESSIBLE_IMAGE_SCHEMA.optional(), //the image of the tile
  texts: z.array(NORMAL_TEXT_SCHEMA), //all texts within the tile
  startDate: z.coerce.date().optional(),
  endDate: z.coerce.date().optional(),
});

export interface ICustomTile {
  id?: CustomTileId;
  isActive: boolean;
  accessibleImage?: IAccessibleImage;
  texts: INormalText[];
  link?: string;
  startDate?: Date;
  endDate?: Date;
}

export const DEFAULT_CUSTOM_TILE_SUBSCRIPTION: ICustomTile = {
  isActive: true,
  accessibleImage: DEFAULT_ACCESSIBLE_IMAGE_EMPTY,
  texts: [
    {
      textType: ETextType.Web,
      text: {
        values: [
          {
            value: 'Abonnements',
            languagePrefix: 'DE' as LanguagePrefix,
          },
        ],
      },
      relationType: ERelationType.title,
      entityType: ERelationType.customTile,
    },
    {
      textType: ETextType.Web,
      text: {
        values: [
          {
            value:
              'Deutschlandticket, Job-Ticket oder Schülerticket hier bestellen.',
            languagePrefix: 'DE' as LanguagePrefix,
          },
        ],
      },
      relationType: ERelationType.descriptionText,
      entityType: ERelationType.customTile,
    },
    {
      textType: ETextType.Web,
      text: {
        values: [
          {
            value: 'Zu den Abos',
            languagePrefix: 'DE' as LanguagePrefix,
          },
        ],
      },
      relationType: ERelationType.iconText,
      entityType: ERelationType.customTile,
    },
  ],
};
export const DEFAULT_CUSTOM_TILE_DIRECT_TICKET: ICustomTile = {
  isActive: true,
  accessibleImage: DEFAULT_ACCESSIBLE_IMAGE_EMPTY,
  texts: [
    {
      textType: ETextType.Web,
      text: {
        values: [
          {
            value: 'Direkt-Tickets',
            languagePrefix: 'DE' as LanguagePrefix,
          },
        ],
      },
      relationType: ERelationType.title,
      entityType: ERelationType.customTile,
    },
    {
      textType: ETextType.Web,
      text: {
        values: [
          {
            value:
              'Einzel-, Gruppen-, Länder-Tickets und mehr Angebote zum Direkt-Losfahren.',
            languagePrefix: 'DE' as LanguagePrefix,
          },
        ],
      },
      relationType: ERelationType.descriptionText,
      entityType: ERelationType.customTile,
    },
    {
      textType: ETextType.Web,
      text: {
        values: [
          {
            value: 'Zu den Angeboten',
            languagePrefix: 'DE' as LanguagePrefix,
          },
        ],
      },
      relationType: ERelationType.iconText,
      entityType: ERelationType.customTile,
    },
  ],
};
